import buyingSessionGroupStore from '@stores/BuyingSessionGroup'
import { VIPClientType } from '@modules/common/models/enums/VIPClientType'
import { VIPChannel } from '@modules/common/models/enums/VIPChannel'
import { config } from '@config'

export const getValidBSGStatuses = (buyingSessionGroupId, clientType) => {
  return buyingSessionGroupStore.hasStatusesByClientType(
    buyingSessionGroupId,
    VIPClientType[clientType] || VIPClientType.External,
    {
      [VIPChannel.Wholesale]: [
        config.appConfig.enumerations.buyingSessionStatus.BUYING_SESSION_STATUS_VALUES
          .BUYING
      ],
      [VIPChannel.Retail]: [
        config.appConfig.enumerations.retailBuyingSessionStatus
          .BUYING_SESSION_STATUS_VALUES.BUYING
      ]
    }
  )
}
